import { lazy, Suspense } from "react"
import { createBrowserRouter, Navigate } from "react-router-dom"
import { AuthLayout } from "@/components/layout/AuthLayout"
import { AuthGuard, FullPageLoader } from "@/features/auth/components/AuthGuard"
import { DatasetGate } from "@/features/auth/components/DatasetGate"

// Nothing imported here may import the hierarchy modules: they need the
// jurisdiction dataset, which exists only after sign-in (see DatasetGate).
const LoginPage = lazy(() => import("@/features/auth/pages/LoginPage"))
const AdminApp = lazy(() => import("@/features/admin/AdminApp"))

export const router = createBrowserRouter([
  {
    path: "/auth",
    element: <AuthLayout />,
    children: [
      { index: true, element: <Navigate to="/auth/login" replace /> },
      { path: "login", element: <Suspense fallback={<FullPageLoader />}><LoginPage /></Suspense> },
    ],
  },
  {
    // System Administrator console (accounts, organisations, audit)
    path: "/admin/*",
    element: (
      <AuthGuard require="admin">
        <Suspense fallback={<FullPageLoader />}><AdminApp /></Suspense>
      </AuthGuard>
    ),
  },
  {
    // The demonstration, limited to the account's jurisdiction
    path: "/*",
    element: (
      <AuthGuard require="demo">
        <DatasetGate />
      </AuthGuard>
    ),
  },
])
